<template>
    <b-dropdown v-if="isMultiLanguage" class="lang-dropdown" no-caret right>
        <template #button-content>
            <img
                class="lang-img w-24-px rounded"
                :src="require('@/assets/images/flags/' + presentLocale.image)"
                :alt="presentLocale.code"
                :title="presentLocale.code"
            />
        </template>
        <b-dropdown-item
            v-for="locale in availableLocales"
            :key="locale.code"
            @click="switchLocale(locale.code)"
        >
            {{ locale.shortName }}
            <img
                :src="require('@/assets/images/flags/' + locale.image)"
                :alt="locale.code"
                :title="locale.code"
                class="w-24-px rounded"
            />
        </b-dropdown-item>
    </b-dropdown>
</template>

<script>
import { WEBSITES } from '@/constants/config';
import i18nLocales from '@/i18n/locales';
import LocaleMixin from '@/mixins/locale';
import { mapGetters } from 'vuex';

export default {
    name: 'LanguageDropdown',
    mixins: [LocaleMixin],
    computed: {
        ...mapGetters('auth', ['loggedIn', 'user']),
        availableLocales() {
            return i18nLocales.filter((i) =>
                i.supportCountries.includes(this.userWebsite)
            );
        },
        presentLocale() {
            return i18nLocales.find((i) => i.code === this.$i18n.locale) || {};
        },
        userWebsite() {
            return this.user?.website?.id || WEBSITES.KH;
        },
        isMultiLanguage() {
            return this.availableLocales.length > 1;
        },
    },
};
</script>

<style scoped></style>
